import React, { Component, createRef } from 'react';
import classNames from 'classnames';

import './styles.css';

const IS_TEST_ENV = process.env.NODE_ENV === 'test';

/**
 * A simple dialog component.
 *
 * @typedef {Object} Props
 * @prop {boolean} [visible]
 * @prop {String} [className]
 * @prop {Function} [onClose]
 *
 * @augments {Component<Props>}
 */
export default class Dialog extends Component {

	static registerDialogPolyfill = async (dialog) => {
		// @ts-ignore
		const dialogPolyfill = await import('dialog-polyfill');
		dialogPolyfill.registerDialog(dialog);
	};

	async componentDidMount () {
		if (IS_TEST_ENV) return;

		// @ts-ignore
		if (!window.HTMLDialogElement) await Dialog.registerDialogPolyfill(this.getDialog());
		if (this.props.visible) this.toggleDialog(true);
		this.getDialog().addEventListener('close', this.handleDialogClose);
	}

	componentDidUpdate ({ visible }) {
		if (this.props.visible === visible) return;
		this.toggleDialog(this.props.visible);
	}

	componentWillUnmount () {
		this.toggleBodyOverflow(true);
		this.getDialog().removeEventListener('close', this.handleDialogClose);
	}

	genClassName = (props) => classNames('Dialog', props.className);

	handleDialogClose = () => {
		this.toggleBodyOverflow(true);
		if (this.props.onClose) this.props.onClose();
	}

	toggleDialog = (shouldShow) => {
		if (shouldShow) {
			this.toggleBodyOverflow(false);
			this.getDialog().showModal();
		} else {
			this.getDialog().close();
		}
	}

	toggleBodyOverflow = (shouldShow) => {
		document.body.style.overflowY = shouldShow ? '' : 'hidden';
	}

	ref = createRef();
	getDialog = () => this.ref.current;

	render () {
		return (
			<dialog ref={this.ref} className={this.genClassName(this.props)}>
				{this.props.children}
			</dialog>
		);
	}

}



// WEBPACK FOOTER //
// ./src/components/atoms/Dialog/Dialog.js